import React, { RefObject, useEffect, useRef, useState } from "react";

import styled from "veneer/styled";
import { OverflowTooltipTypography } from "veneer/Typography";

import { Collapsible } from "cortex/ui/src/ui/collapsible";

export default function EventMessageCell({ message }: { message: string }) {
  const ref = useRef(null) as RefObject<HTMLSpanElement>;
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }

    const checkOverflow = () => {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    };

    checkOverflow();
    const observer = new ResizeObserver(checkOverflow);
    observer.observe(el);

    return () => observer.disconnect();
  }, [message]);

  return (
    <>
      <HiddenSpan ref={ref}>{message}</HiddenSpan>
      {isTruncated ? (
        <Collapsible
          label={
            <OverflowTooltipTypography variant="body2">
              {message}
            </OverflowTooltipTypography>
          }
        >
          <Pre>{message}</Pre>
        </Collapsible>
      ) : (
        <>{message}</>
      )}
    </>
  );
}

const HiddenSpan = styled("span")({
  display: "block",
  height: 0,
  overflow: "hidden",
  pointerEvents: "none",
  textOverflow: "ellipsis",
  visibility: "hidden",
  whiteSpace: "nowrap",
});

const Pre = styled("pre")(({ theme }) => ({
  lineHeight: 1.5,
  overflowWrap: "anywhere",
  margin: 0,
  padding: theme.spacing(1, 0),
  whiteSpace: "pre-wrap",
}));
